import React, { useEffect, useState } from "react";
import { Grid2, Typography, Card, Button } from "@mui/material";
import { Link, Navigate } from "react-router-dom";
import { useApi } from "../../utils/api";
import { useAuth } from "../../utils/auth";
import { useUserInfo } from "../../utils/user";

const Coaching = () => {
  const { user } = useAuth();
  const { stripeAccountId } = useUserInfo();
  const { getAccount } = useApi();
  const [accountLinked, setAccountLinked] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAccount = async () => {
      setLoading(true);
      const account = await getAccount(stripeAccountId);
      if (!account) {
        setError(
          "Failed to get account. Please try again. Error: " +
            account.statusText
        );
      }
      if (account.details_submitted) {
        setAccountLinked(true);
      } else {
        setAccountLinked(false);
      }
      setLoading(false);
    };
    checkAccount();
  }, [stripeAccountId]);

  return (
    <Grid2 sx={{ mt: 4 }}>
      {!user && <Navigate to="/coaching/landing" />}
      {user && !stripeAccountId && <Navigate to="/coaching/create-account" />}
      {user && stripeAccountId && !accountLinked && (
        <Navigate to="/coaching/create-account-link" />
      )}
      {user && stripeAccountId && accountLinked && (
        <Navigate to="/coaching/complete" />
      )}
    </Grid2>
  );
};

const AccountCreated = () => {
  const { updateUser } = useApi();
  useEffect(() => {
    updateUser({
      onboardingStep: STEPS.ACCOUNT_LINKED,
    });
  }, []);
  return (
    <Grid2 container justifyContent="center" sx={{ m: 4 }}>
      <Grid2 item lg={6} sm={12}>
        <Card sx={{ p: 3, mt: 4 }}>
          <Typography variant="h5" sx={{ mb: 3, textAlign: "center" }}>
            Account Created Successfully!
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            You can now start accepting payments and managing your clients.
          </Typography>
          <Button
            variant="contained"
            component={Link}
            to="/clients"
            sx={{ mt: 2, display: "block", mx: "auto" }}
          >
            Go to Dashboard
          </Button>
        </Card>
      </Grid2>
    </Grid2>
  );
};

export default Coaching;
